// extracted by mini-css-extract-plugin
export default {"root":"style_root__6Zzhu"};